import { AskResponse, getCitationFilePath } from "../../api";
import { Stack } from "@fluentui/react";
import React, { useState } from "react"; // Import useState from React
import styles from "./Answer.module.css";
import { Button } from "semantic-ui-react";

interface propsData {
    arraydocs: { linksFiltered: string[]; idLinks: string[] };
    citacion: string[];
    answer: AskResponse;
    onCitationClicked: (filePath: string) => void;
    origin: string;
    seccion: string;
}

export function originLink(origin: string, seccion: string): string {
    let mockLegadoOrTelco = seccion === 'B2B' ? 'Legado intranet'
                    : 'Telco intranet'
    let mockOrigin = mockLegadoOrTelco === 'Legado intranet' ? 'https://wcrc.es.telefonica/elypseplus' 
                        : 'https://t3.telefonica.es/elypseplus'
    if(origin) {
        let firstPartUrl = origin.split(':')[0] + ':' + origin.split(':')[1];
        let secondPartUrlArray = origin.split(':').length > 2 ? origin.split(':')[2].split('/')
                                    : []
        if(secondPartUrlArray.length > 0) secondPartUrlArray.shift()
        if(secondPartUrlArray.length > 0) secondPartUrlArray.pop()
        let secondPartUrl = secondPartUrlArray.length > 0 ? '/' + secondPartUrlArray.join('') 
                            : ''
        return firstPartUrl + secondPartUrl
    }
    else return mockOrigin
}

export const AnswerLinks = ({ arraydocs, answer, onCitationClicked, origin, seccion }: propsData) => {
    const url = "/render/genericRender.xhtml?id=";
    const [Mostrar, setMostrar] = useState(false);
    const toggleMostrar = () => setMostrar(!Mostrar);
    origin = originLink(origin, seccion);

    return (
        <Stack.Item>
            <Stack className={styles.linksModule} horizontal wrap tokens={{ childrenGap: 5 }}>
                <span className={styles.citationLearnMore}>
                    {arraydocs.linksFiltered.some(element => {
                        return element;
                    })
                        ? "Más información:"
                        : ""}
                </span>
                <ul>
                    {arraydocs.linksFiltered.map((x, i) => {
                        if (x) {
                            let style = styles.citation;
                            if (x.includes("False")) style = styles.citationFalse;

                            const path = getCitationFilePath(x);
                            if (x.includes("True")) x = x.replace("- True", "");

                            if (x.includes("False")) x = x.replace("- False", "");
                            let docid = x.substring(0, x.indexOf(" "));
                            let sectionid = x.substring(x.indexOf("|!") + 2);
                            let href = origin + url + `${docid}` + "&type=0" + '&source=chat';
                            if (sectionid != "") {
                                href = origin + url + `${docid}` + "&p=" + `${sectionid}` + "&type=0" + '&source=chat';
                            }

                            return (
                                <li key={i} style={{ listStyle: "decimal" }}>
                                    <a className={style} title={x.substring(0, x.indexOf("|!"))} target="_blank" href={href}>
                                        {`${x.substring(0, x.indexOf("|!"))}`} {/*página ${(parseInt(pageLinks[i]) + 1).toString()}*/}
                                    </a>
                                </li>
                            );
                        } else {
                            return null;
                        }
                    })}
                </ul>
                <br></br>
            </Stack>
            <Stack className={styles.linksModule} horizontal wrap tokens={{ childrenGap: 5 }} style={{ flexDirection: "row-reverse" }}>
                <span className={styles.citationLearnMore}>
                    {answer != null && answer.azs_links != null && answer.azs_links.length > 0 && (
                        <React.Fragment>
                            <Button className={styles.button} onClick={toggleMostrar}>
                                Otros enlaces de interés{" "}
                                {Mostrar ? (
                                    // Flecha hacia arriba cuando está mostrando
                                    <span>&#9650;</span>
                                ) : (
                                    // Flecha hacia abajo cuando está oculto
                                    <span>&#9660;</span>
                                )}
                            </Button>
                            {Mostrar && (
                                <ul>
                                    {answer.azs_links.map((x, i) => {
                                        if (x) {
                                            let style = styles.citation;
                                            if (x.vigente == "False") style = styles.citationFalse;

                                            return (
                                                <li key={i} style={{ listStyle: "decimal" }}>
                                                    <a className={style} title={x.title} target="_blank" href={origin + url + `${x.id}` + "&type=0" + '&source=chat'}>
                                                        {`${x.id} - "${x.title}" - (${x.vigencia_dates})`}
                                                    </a>
                                                </li>
                                            );
                                        } else {
                                            return null;
                                        }
                                    })}
                                </ul>
                            )}
                        </React.Fragment>
                    )}
                </span>
            </Stack>
        </Stack.Item>
    );
};
